"use strict";

exports.__esModule = true;
exports.marginTopClasses = exports.marginRightClasses = exports.marginLeftClasses = exports.marginClasses = exports.marginBottomClasses = exports.getMargin = exports.default = exports.SIZES = void 0;
var _mediaQuery = require("../../utils/mediaQuery");
let SIZES = exports.SIZES = /*#__PURE__*/function (SIZES) {
  SIZES["NONE"] = "none";
  SIZES["FIFTY"] = "50";
  SIZES["ONE_HUNDRED"] = "100";
  SIZES["ONE_HUNDRED_FIFTY"] = "150";
  SIZES["TWO_HUNDRED"] = "200";
  SIZES["THREE_HUNDRED"] = "300";
  SIZES["FOUR_HUNDRED"] = "400";
  SIZES["FIVE_HUNDRED"] = "500";
  SIZES["SIX_HUNDRED"] = "600";
  SIZES["EIGHT_HUNDRED"] = "800";
  SIZES["ONE_THOUSAND"] = "1000";
  SIZES["ONE_THOUSAND_TWO_HUNDRED"] = "1200";
  SIZES["ONE_THOUSAND_SIX_HUNDRED"] = "1600";
  return SIZES;
}({});
const marginClasses = exports.marginClasses = {
  [SIZES.NONE]: "m-0",
  [SIZES.FIFTY]: "m-50",
  [SIZES.ONE_HUNDRED]: "m-100",
  [SIZES.ONE_HUNDRED_FIFTY]: "m-150",
  [SIZES.TWO_HUNDRED]: "m-200",
  [SIZES.THREE_HUNDRED]: "m-300",
  [SIZES.FOUR_HUNDRED]: "m-400",
  [SIZES.FIVE_HUNDRED]: "m-500",
  [SIZES.SIX_HUNDRED]: "m-600",
  [SIZES.EIGHT_HUNDRED]: "m-800",
  [SIZES.ONE_THOUSAND]: "m-1000",
  [SIZES.ONE_THOUSAND_TWO_HUNDRED]: "m-1200",
  [SIZES.ONE_THOUSAND_SIX_HUNDRED]: "m-1600",
  [_mediaQuery.QUERIES.LARGEDESKTOP]: {
    [SIZES.NONE]: "ld:m-0",
    [SIZES.FIFTY]: "ld:m-50",
    [SIZES.ONE_HUNDRED]: "ld:m-100",
    [SIZES.ONE_HUNDRED_FIFTY]: "ld:m-150",
    [SIZES.TWO_HUNDRED]: "ld:m-200",
    [SIZES.THREE_HUNDRED]: "ld:m-300",
    [SIZES.FOUR_HUNDRED]: "ld:m-400",
    [SIZES.FIVE_HUNDRED]: "ld:m-500",
    [SIZES.SIX_HUNDRED]: "ld:m-600",
    [SIZES.EIGHT_HUNDRED]: "ld:m-800",
    [SIZES.ONE_THOUSAND]: "ld:m-1000",
    [SIZES.ONE_THOUSAND_TWO_HUNDRED]: "ld:m-1200",
    [SIZES.ONE_THOUSAND_SIX_HUNDRED]: "ld:m-1600"
  },
  [_mediaQuery.QUERIES.DESKTOP]: {
    [SIZES.NONE]: "de:m-0",
    [SIZES.FIFTY]: "de:m-50",
    [SIZES.ONE_HUNDRED]: "de:m-100",
    [SIZES.ONE_HUNDRED_FIFTY]: "de:m-150",
    [SIZES.TWO_HUNDRED]: "de:m-200",
    [SIZES.THREE_HUNDRED]: "de:m-300",
    [SIZES.FOUR_HUNDRED]: "de:m-400",
    [SIZES.FIVE_HUNDRED]: "de:m-500",
    [SIZES.SIX_HUNDRED]: "de:m-600",
    [SIZES.EIGHT_HUNDRED]: "de:m-800",
    [SIZES.ONE_THOUSAND]: "de:m-1000",
    [SIZES.ONE_THOUSAND_TWO_HUNDRED]: "de:m-1200",
    [SIZES.ONE_THOUSAND_SIX_HUNDRED]: "de:m-1600"
  },
  [_mediaQuery.QUERIES.TABLET]: {
    [SIZES.NONE]: "tb:m-0",
    [SIZES.FIFTY]: "tb:m-50",
    [SIZES.ONE_HUNDRED]: "tb:m-100",
    [SIZES.ONE_HUNDRED_FIFTY]: "tb:m-150",
    [SIZES.TWO_HUNDRED]: "tb:m-200",
    [SIZES.THREE_HUNDRED]: "tb:m-300",
    [SIZES.FOUR_HUNDRED]: "tb:m-400",
    [SIZES.FIVE_HUNDRED]: "tb:m-500",
    [SIZES.SIX_HUNDRED]: "tb:m-600",
    [SIZES.EIGHT_HUNDRED]: "tb:m-800",
    [SIZES.ONE_THOUSAND]: "tb:m-1000",
    [SIZES.ONE_THOUSAND_TWO_HUNDRED]: "tb:m-1200",
    [SIZES.ONE_THOUSAND_SIX_HUNDRED]: "tb:m-1600"
  },
  [_mediaQuery.QUERIES.LARGEMOBILE]: {
    [SIZES.NONE]: "lm:m-0",
    [SIZES.FIFTY]: "lm:m-50",
    [SIZES.ONE_HUNDRED]: "lm:m-100",
    [SIZES.ONE_HUNDRED_FIFTY]: "lm:m-150",
    [SIZES.TWO_HUNDRED]: "lm:m-200",
    [SIZES.THREE_HUNDRED]: "lm:m-300",
    [SIZES.FOUR_HUNDRED]: "lm:m-400",
    [SIZES.FIVE_HUNDRED]: "lm:m-500",
    [SIZES.SIX_HUNDRED]: "lm:m-600",
    [SIZES.EIGHT_HUNDRED]: "lm:m-800",
    [SIZES.ONE_THOUSAND]: "lm:m-1000",
    [SIZES.ONE_THOUSAND_TWO_HUNDRED]: "lm:m-1200",
    [SIZES.ONE_THOUSAND_SIX_HUNDRED]: "lm:m-1600"
  },
  [_mediaQuery.QUERIES.MEDIUMMOBILE]: {
    [SIZES.NONE]: "mm:m-0",
    [SIZES.FIFTY]: "mm:m-50",
    [SIZES.ONE_HUNDRED]: "mm:m-100",
    [SIZES.ONE_HUNDRED_FIFTY]: "mm:m-150",
    [SIZES.TWO_HUNDRED]: "mm:m-200",
    [SIZES.THREE_HUNDRED]: "mm:m-300",
    [SIZES.FOUR_HUNDRED]: "mm:m-400",
    [SIZES.FIVE_HUNDRED]: "mm:m-500",
    [SIZES.SIX_HUNDRED]: "mm:m-600",
    [SIZES.EIGHT_HUNDRED]: "mm:m-800",
    [SIZES.ONE_THOUSAND]: "mm:m-1000",
    [SIZES.ONE_THOUSAND_TWO_HUNDRED]: "mm:m-1200",
    [SIZES.ONE_THOUSAND_SIX_HUNDRED]: "mm:m-1600"
  }
};
const marginTopClasses = exports.marginTopClasses = {
  [SIZES.NONE]: "mt-0",
  [SIZES.FIFTY]: "mt-50",
  [SIZES.ONE_HUNDRED]: "mt-100",
  [SIZES.ONE_HUNDRED_FIFTY]: "mt-150",
  [SIZES.TWO_HUNDRED]: "mt-200",
  [SIZES.THREE_HUNDRED]: "mt-300",
  [SIZES.FOUR_HUNDRED]: "mt-400",
  [SIZES.FIVE_HUNDRED]: "mt-500",
  [SIZES.SIX_HUNDRED]: "mt-600",
  [SIZES.EIGHT_HUNDRED]: "mt-800",
  [SIZES.ONE_THOUSAND]: "mt-1000",
  [SIZES.ONE_THOUSAND_TWO_HUNDRED]: "mt-1200",
  [SIZES.ONE_THOUSAND_SIX_HUNDRED]: "mt-1600",
  [_mediaQuery.QUERIES.LARGEDESKTOP]: {
    [SIZES.NONE]: "ld:mt-0",
    [SIZES.FIFTY]: "ld:mt-50",
    [SIZES.ONE_HUNDRED]: "ld:mt-100",
    [SIZES.ONE_HUNDRED_FIFTY]: "ld:mt-150",
    [SIZES.TWO_HUNDRED]: "ld:mt-200",
    [SIZES.THREE_HUNDRED]: "ld:mt-300",
    [SIZES.FOUR_HUNDRED]: "ld:mt-400",
    [SIZES.FIVE_HUNDRED]: "ld:mt-500",
    [SIZES.SIX_HUNDRED]: "ld:mt-600",
    [SIZES.EIGHT_HUNDRED]: "ld:mt-800",
    [SIZES.ONE_THOUSAND]: "ld:mt-1000",
    [SIZES.ONE_THOUSAND_TWO_HUNDRED]: "ld:mt-1200",
    [SIZES.ONE_THOUSAND_SIX_HUNDRED]: "ld:mt-1600"
  },
  [_mediaQuery.QUERIES.DESKTOP]: {
    [SIZES.NONE]: "de:mt-0",
    [SIZES.FIFTY]: "de:mt-50",
    [SIZES.ONE_HUNDRED]: "de:mt-100",
    [SIZES.ONE_HUNDRED_FIFTY]: "de:mt-150",
    [SIZES.TWO_HUNDRED]: "de:mt-200",
    [SIZES.THREE_HUNDRED]: "de:mt-300",
    [SIZES.FOUR_HUNDRED]: "de:mt-400",
    [SIZES.FIVE_HUNDRED]: "de:mt-500",
    [SIZES.SIX_HUNDRED]: "de:mt-600",
    [SIZES.EIGHT_HUNDRED]: "de:mt-800",
    [SIZES.ONE_THOUSAND]: "de:mt-1000",
    [SIZES.ONE_THOUSAND_TWO_HUNDRED]: "de:mt-1200",
    [SIZES.ONE_THOUSAND_SIX_HUNDRED]: "de:mt-1600"
  },
  [_mediaQuery.QUERIES.TABLET]: {
    [SIZES.NONE]: "tb:mt-0",
    [SIZES.FIFTY]: "tb:mt-50",
    [SIZES.ONE_HUNDRED]: "tb:mt-100",
    [SIZES.ONE_HUNDRED_FIFTY]: "tb:mt-150",
    [SIZES.TWO_HUNDRED]: "tb:mt-200",
    [SIZES.THREE_HUNDRED]: "tb:mt-300",
    [SIZES.FOUR_HUNDRED]: "tb:mt-400",
    [SIZES.FIVE_HUNDRED]: "tb:mt-500",
    [SIZES.SIX_HUNDRED]: "tb:mt-600",
    [SIZES.EIGHT_HUNDRED]: "tb:mt-800",
    [SIZES.ONE_THOUSAND]: "tb:mt-1000",
    [SIZES.ONE_THOUSAND_TWO_HUNDRED]: "tb:mt-1200",
    [SIZES.ONE_THOUSAND_SIX_HUNDRED]: "tb:mt-1600"
  },
  [_mediaQuery.QUERIES.LARGEMOBILE]: {
    [SIZES.NONE]: "lm:mt-0",
    [SIZES.FIFTY]: "lm:mt-50",
    [SIZES.ONE_HUNDRED]: "lm:mt-100",
    [SIZES.ONE_HUNDRED_FIFTY]: "lm:mt-150",
    [SIZES.TWO_HUNDRED]: "lm:mt-200",
    [SIZES.THREE_HUNDRED]: "lm:mt-300",
    [SIZES.FOUR_HUNDRED]: "lm:mt-400",
    [SIZES.FIVE_HUNDRED]: "lm:mt-500",
    [SIZES.SIX_HUNDRED]: "lm:mt-600",
    [SIZES.EIGHT_HUNDRED]: "lm:mt-800",
    [SIZES.ONE_THOUSAND]: "lm:mt-1000",
    [SIZES.ONE_THOUSAND_TWO_HUNDRED]: "lm:mt-1200",
    [SIZES.ONE_THOUSAND_SIX_HUNDRED]: "lm:mt-1600"
  },
  [_mediaQuery.QUERIES.MEDIUMMOBILE]: {
    [SIZES.NONE]: "mm:mt-0",
    [SIZES.FIFTY]: "mm:mt-50",
    [SIZES.ONE_HUNDRED]: "mm:mt-100",
    [SIZES.ONE_HUNDRED_FIFTY]: "mm:mt-150",
    [SIZES.TWO_HUNDRED]: "mm:mt-200",
    [SIZES.THREE_HUNDRED]: "mm:mt-300",
    [SIZES.FOUR_HUNDRED]: "mm:mt-400",
    [SIZES.FIVE_HUNDRED]: "mm:mt-500",
    [SIZES.SIX_HUNDRED]: "mm:mt-600",
    [SIZES.EIGHT_HUNDRED]: "mm:mt-800",
    [SIZES.ONE_THOUSAND]: "mm:mt-1000",
    [SIZES.ONE_THOUSAND_TWO_HUNDRED]: "mm:mt-1200",
    [SIZES.ONE_THOUSAND_SIX_HUNDRED]: "mm:mt-1600"
  }
};
const marginRightClasses = exports.marginRightClasses = {
  [SIZES.NONE]: "mr-0",
  [SIZES.FIFTY]: "mr-50",
  [SIZES.ONE_HUNDRED]: "mr-100",
  [SIZES.ONE_HUNDRED_FIFTY]: "mr-150",
  [SIZES.TWO_HUNDRED]: "mr-200",
  [SIZES.THREE_HUNDRED]: "mr-300",
  [SIZES.FOUR_HUNDRED]: "mr-400",
  [SIZES.FIVE_HUNDRED]: "mr-500",
  [SIZES.SIX_HUNDRED]: "mr-600",
  [SIZES.EIGHT_HUNDRED]: "mr-800",
  [SIZES.ONE_THOUSAND]: "mr-1000",
  [SIZES.ONE_THOUSAND_TWO_HUNDRED]: "mr-1200",
  [SIZES.ONE_THOUSAND_SIX_HUNDRED]: "mr-1600",
  [_mediaQuery.QUERIES.LARGEDESKTOP]: {
    [SIZES.NONE]: "ld:mr-0",
    [SIZES.FIFTY]: "ld:mr-50",
    [SIZES.ONE_HUNDRED]: "ld:mr-100",
    [SIZES.ONE_HUNDRED_FIFTY]: "ld:mr-150",
    [SIZES.TWO_HUNDRED]: "ld:mr-200",
    [SIZES.THREE_HUNDRED]: "ld:mr-300",
    [SIZES.FOUR_HUNDRED]: "ld:mr-400",
    [SIZES.FIVE_HUNDRED]: "ld:mr-500",
    [SIZES.SIX_HUNDRED]: "ld:mr-600",
    [SIZES.EIGHT_HUNDRED]: "ld:mr-800",
    [SIZES.ONE_THOUSAND]: "ld:mr-1000",
    [SIZES.ONE_THOUSAND_TWO_HUNDRED]: "ld:mr-1200",
    [SIZES.ONE_THOUSAND_SIX_HUNDRED]: "ld:mr-1600"
  },
  [_mediaQuery.QUERIES.DESKTOP]: {
    [SIZES.NONE]: "de:mr-0",
    [SIZES.FIFTY]: "de:mr-50",
    [SIZES.ONE_HUNDRED]: "de:mr-100",
    [SIZES.ONE_HUNDRED_FIFTY]: "de:mr-150",
    [SIZES.TWO_HUNDRED]: "de:mr-200",
    [SIZES.THREE_HUNDRED]: "de:mr-300",
    [SIZES.FOUR_HUNDRED]: "de:mr-400",
    [SIZES.FIVE_HUNDRED]: "de:mr-500",
    [SIZES.SIX_HUNDRED]: "de:mr-600",
    [SIZES.EIGHT_HUNDRED]: "de:mr-800",
    [SIZES.ONE_THOUSAND]: "de:mr-1000",
    [SIZES.ONE_THOUSAND_TWO_HUNDRED]: "de:mr-1200",
    [SIZES.ONE_THOUSAND_SIX_HUNDRED]: "de:mr-1600"
  },
  [_mediaQuery.QUERIES.TABLET]: {
    [SIZES.NONE]: "tb:mr-0",
    [SIZES.FIFTY]: "tb:mr-50",
    [SIZES.ONE_HUNDRED]: "tb:mr-100",
    [SIZES.ONE_HUNDRED_FIFTY]: "tb:mr-150",
    [SIZES.TWO_HUNDRED]: "tb:mr-200",
    [SIZES.THREE_HUNDRED]: "tb:mr-300",
    [SIZES.FOUR_HUNDRED]: "tb:mr-400",
    [SIZES.FIVE_HUNDRED]: "tb:mr-500",
    [SIZES.SIX_HUNDRED]: "tb:mr-600",
    [SIZES.EIGHT_HUNDRED]: "tb:mr-800",
    [SIZES.ONE_THOUSAND]: "tb:mr-1000",
    [SIZES.ONE_THOUSAND_TWO_HUNDRED]: "tb:mr-1200",
    [SIZES.ONE_THOUSAND_SIX_HUNDRED]: "tb:mr-1600"
  },
  [_mediaQuery.QUERIES.LARGEMOBILE]: {
    [SIZES.NONE]: "lm:mr-0",
    [SIZES.FIFTY]: "lm:mr-50",
    [SIZES.ONE_HUNDRED]: "lm:mr-100",
    [SIZES.ONE_HUNDRED_FIFTY]: "lm:mr-150",
    [SIZES.TWO_HUNDRED]: "lm:mr-200",
    [SIZES.THREE_HUNDRED]: "lm:mr-300",
    [SIZES.FOUR_HUNDRED]: "lm:mr-400",
    [SIZES.FIVE_HUNDRED]: "lm:mr-500",
    [SIZES.SIX_HUNDRED]: "lm:mr-600",
    [SIZES.EIGHT_HUNDRED]: "lm:mr-800",
    [SIZES.ONE_THOUSAND]: "lm:mr-1000",
    [SIZES.ONE_THOUSAND_TWO_HUNDRED]: "lm:mr-1200",
    [SIZES.ONE_THOUSAND_SIX_HUNDRED]: "lm:mr-1600"
  },
  [_mediaQuery.QUERIES.MEDIUMMOBILE]: {
    [SIZES.NONE]: "mm:mr-0",
    [SIZES.FIFTY]: "mm:mr-50",
    [SIZES.ONE_HUNDRED]: "mm:mr-100",
    [SIZES.ONE_HUNDRED_FIFTY]: "mm:mr-150",
    [SIZES.TWO_HUNDRED]: "mm:mr-200",
    [SIZES.THREE_HUNDRED]: "mm:mr-300",
    [SIZES.FOUR_HUNDRED]: "mm:mr-400",
    [SIZES.FIVE_HUNDRED]: "mm:mr-500",
    [SIZES.SIX_HUNDRED]: "mm:mr-600",
    [SIZES.EIGHT_HUNDRED]: "mm:mr-800",
    [SIZES.ONE_THOUSAND]: "mm:mr-1000",
    [SIZES.ONE_THOUSAND_TWO_HUNDRED]: "mm:mr-1200",
    [SIZES.ONE_THOUSAND_SIX_HUNDRED]: "mm:mr-1600"
  }
};
const marginBottomClasses = exports.marginBottomClasses = {
  [SIZES.NONE]: "mb-0",
  [SIZES.FIFTY]: "mb-50",
  [SIZES.ONE_HUNDRED]: "mb-100",
  [SIZES.ONE_HUNDRED_FIFTY]: "mb-150",
  [SIZES.TWO_HUNDRED]: "mb-200",
  [SIZES.THREE_HUNDRED]: "mb-300",
  [SIZES.FOUR_HUNDRED]: "mb-400",
  [SIZES.FIVE_HUNDRED]: "mb-500",
  [SIZES.SIX_HUNDRED]: "mb-600",
  [SIZES.EIGHT_HUNDRED]: "mb-800",
  [SIZES.ONE_THOUSAND]: "mb-1000",
  [SIZES.ONE_THOUSAND_TWO_HUNDRED]: "mb-1200",
  [SIZES.ONE_THOUSAND_SIX_HUNDRED]: "mb-1600",
  [_mediaQuery.QUERIES.LARGEDESKTOP]: {
    [SIZES.NONE]: "ld:mb-0",
    [SIZES.FIFTY]: "ld:mb-50",
    [SIZES.ONE_HUNDRED]: "ld:mb-100",
    [SIZES.ONE_HUNDRED_FIFTY]: "ld:mb-150",
    [SIZES.TWO_HUNDRED]: "ld:mb-200",
    [SIZES.THREE_HUNDRED]: "ld:mb-300",
    [SIZES.FOUR_HUNDRED]: "ld:mb-400",
    [SIZES.FIVE_HUNDRED]: "ld:mb-500",
    [SIZES.SIX_HUNDRED]: "ld:mb-600",
    [SIZES.EIGHT_HUNDRED]: "ld:mb-800",
    [SIZES.ONE_THOUSAND]: "ld:mb-1000",
    [SIZES.ONE_THOUSAND_TWO_HUNDRED]: "ld:mb-1200",
    [SIZES.ONE_THOUSAND_SIX_HUNDRED]: "ld:mb-1600"
  },
  [_mediaQuery.QUERIES.DESKTOP]: {
    [SIZES.NONE]: "de:mb-0",
    [SIZES.FIFTY]: "de:mb-50",
    [SIZES.ONE_HUNDRED]: "de:mb-100",
    [SIZES.ONE_HUNDRED_FIFTY]: "de:mb-150",
    [SIZES.TWO_HUNDRED]: "de:mb-200",
    [SIZES.THREE_HUNDRED]: "de:mb-300",
    [SIZES.FOUR_HUNDRED]: "de:mb-400",
    [SIZES.FIVE_HUNDRED]: "de:mb-500",
    [SIZES.SIX_HUNDRED]: "de:mb-600",
    [SIZES.EIGHT_HUNDRED]: "de:mb-800",
    [SIZES.ONE_THOUSAND]: "de:mb-1000",
    [SIZES.ONE_THOUSAND_TWO_HUNDRED]: "de:mb-1200",
    [SIZES.ONE_THOUSAND_SIX_HUNDRED]: "de:mb-1600"
  },
  [_mediaQuery.QUERIES.TABLET]: {
    [SIZES.NONE]: "tb:mb-0",
    [SIZES.FIFTY]: "tb:mb-50",
    [SIZES.ONE_HUNDRED]: "tb:mb-100",
    [SIZES.ONE_HUNDRED_FIFTY]: "tb:mb-150",
    [SIZES.TWO_HUNDRED]: "tb:mb-200",
    [SIZES.THREE_HUNDRED]: "tb:mb-300",
    [SIZES.FOUR_HUNDRED]: "tb:mb-400",
    [SIZES.FIVE_HUNDRED]: "tb:mb-500",
    [SIZES.SIX_HUNDRED]: "tb:mb-600",
    [SIZES.EIGHT_HUNDRED]: "tb:mb-800",
    [SIZES.ONE_THOUSAND]: "tb:mb-1000",
    [SIZES.ONE_THOUSAND_TWO_HUNDRED]: "tb:mb-1200",
    [SIZES.ONE_THOUSAND_SIX_HUNDRED]: "tb:mb-1600"
  },
  [_mediaQuery.QUERIES.LARGEMOBILE]: {
    [SIZES.NONE]: "lm:mb-0",
    [SIZES.FIFTY]: "lm:mb-50",
    [SIZES.ONE_HUNDRED]: "lm:mb-100",
    [SIZES.ONE_HUNDRED_FIFTY]: "lm:mb-150",
    [SIZES.TWO_HUNDRED]: "lm:mb-200",
    [SIZES.THREE_HUNDRED]: "lm:mb-300",
    [SIZES.FOUR_HUNDRED]: "lm:mb-400",
    [SIZES.FIVE_HUNDRED]: "lm:mb-500",
    [SIZES.SIX_HUNDRED]: "lm:mb-600",
    [SIZES.EIGHT_HUNDRED]: "lm:mb-800",
    [SIZES.ONE_THOUSAND]: "lm:mb-1000",
    [SIZES.ONE_THOUSAND_TWO_HUNDRED]: "lm:mb-1200",
    [SIZES.ONE_THOUSAND_SIX_HUNDRED]: "lm:mb-1600"
  },
  [_mediaQuery.QUERIES.MEDIUMMOBILE]: {
    [SIZES.NONE]: "mm:mb-0",
    [SIZES.FIFTY]: "mm:mb-50",
    [SIZES.ONE_HUNDRED]: "mm:mb-100",
    [SIZES.ONE_HUNDRED_FIFTY]: "mm:mb-150",
    [SIZES.TWO_HUNDRED]: "mm:mb-200",
    [SIZES.THREE_HUNDRED]: "mm:mb-300",
    [SIZES.FOUR_HUNDRED]: "mm:mb-400",
    [SIZES.FIVE_HUNDRED]: "mm:mb-500",
    [SIZES.SIX_HUNDRED]: "mm:mb-600",
    [SIZES.EIGHT_HUNDRED]: "mm:mb-800",
    [SIZES.ONE_THOUSAND]: "mm:mb-1000",
    [SIZES.ONE_THOUSAND_TWO_HUNDRED]: "mm:mb-1200",
    [SIZES.ONE_THOUSAND_SIX_HUNDRED]: "mm:mb-1600"
  }
};
const marginLeftClasses = exports.marginLeftClasses = {
  [SIZES.NONE]: "ml-0",
  [SIZES.FIFTY]: "ml-50",
  [SIZES.ONE_HUNDRED]: "ml-100",
  [SIZES.ONE_HUNDRED_FIFTY]: "ml-150",
  [SIZES.TWO_HUNDRED]: "ml-200",
  [SIZES.THREE_HUNDRED]: "ml-300",
  [SIZES.FOUR_HUNDRED]: "ml-400",
  [SIZES.FIVE_HUNDRED]: "ml-500",
  [SIZES.SIX_HUNDRED]: "ml-600",
  [SIZES.EIGHT_HUNDRED]: "ml-800",
  [SIZES.ONE_THOUSAND]: "ml-1000",
  [SIZES.ONE_THOUSAND_TWO_HUNDRED]: "ml-1200",
  [SIZES.ONE_THOUSAND_SIX_HUNDRED]: "ml-1600",
  [_mediaQuery.QUERIES.LARGEDESKTOP]: {
    [SIZES.NONE]: "ld:ml-0",
    [SIZES.FIFTY]: "ld:ml-50",
    [SIZES.ONE_HUNDRED]: "ld:ml-100",
    [SIZES.ONE_HUNDRED_FIFTY]: "ld:ml-150",
    [SIZES.TWO_HUNDRED]: "ld:ml-200",
    [SIZES.THREE_HUNDRED]: "ld:ml-300",
    [SIZES.FOUR_HUNDRED]: "ld:ml-400",
    [SIZES.FIVE_HUNDRED]: "ld:ml-500",
    [SIZES.SIX_HUNDRED]: "ld:ml-600",
    [SIZES.EIGHT_HUNDRED]: "ld:ml-800",
    [SIZES.ONE_THOUSAND]: "ld:ml-1000",
    [SIZES.ONE_THOUSAND_TWO_HUNDRED]: "ld:ml-1200",
    [SIZES.ONE_THOUSAND_SIX_HUNDRED]: "ld:ml-1600"
  },
  [_mediaQuery.QUERIES.DESKTOP]: {
    [SIZES.NONE]: "de:ml-0",
    [SIZES.FIFTY]: "de:ml-50",
    [SIZES.ONE_HUNDRED]: "de:ml-100",
    [SIZES.ONE_HUNDRED_FIFTY]: "de:ml-150",
    [SIZES.TWO_HUNDRED]: "de:ml-200",
    [SIZES.THREE_HUNDRED]: "de:ml-300",
    [SIZES.FOUR_HUNDRED]: "de:ml-400",
    [SIZES.FIVE_HUNDRED]: "de:ml-500",
    [SIZES.SIX_HUNDRED]: "de:ml-600",
    [SIZES.EIGHT_HUNDRED]: "de:ml-800",
    [SIZES.ONE_THOUSAND]: "de:ml-1000",
    [SIZES.ONE_THOUSAND_TWO_HUNDRED]: "de:ml-1200",
    [SIZES.ONE_THOUSAND_SIX_HUNDRED]: "de:ml-1600"
  },
  [_mediaQuery.QUERIES.TABLET]: {
    [SIZES.NONE]: "tb:ml-0",
    [SIZES.FIFTY]: "tb:ml-50",
    [SIZES.ONE_HUNDRED]: "tb:ml-100",
    [SIZES.ONE_HUNDRED_FIFTY]: "tb:ml-150",
    [SIZES.TWO_HUNDRED]: "tb:ml-200",
    [SIZES.THREE_HUNDRED]: "tb:ml-300",
    [SIZES.FOUR_HUNDRED]: "tb:ml-400",
    [SIZES.FIVE_HUNDRED]: "tb:ml-500",
    [SIZES.SIX_HUNDRED]: "tb:ml-600",
    [SIZES.EIGHT_HUNDRED]: "tb:ml-800",
    [SIZES.ONE_THOUSAND]: "tb:ml-1000",
    [SIZES.ONE_THOUSAND_TWO_HUNDRED]: "tb:ml-1200",
    [SIZES.ONE_THOUSAND_SIX_HUNDRED]: "tb:ml-1600"
  },
  [_mediaQuery.QUERIES.LARGEMOBILE]: {
    [SIZES.NONE]: "lm:ml-0",
    [SIZES.FIFTY]: "lm:ml-50",
    [SIZES.ONE_HUNDRED]: "lm:ml-100",
    [SIZES.ONE_HUNDRED_FIFTY]: "lm:ml-150",
    [SIZES.TWO_HUNDRED]: "lm:ml-200",
    [SIZES.THREE_HUNDRED]: "lm:ml-300",
    [SIZES.FOUR_HUNDRED]: "lm:ml-400",
    [SIZES.FIVE_HUNDRED]: "lm:ml-500",
    [SIZES.SIX_HUNDRED]: "lm:ml-600",
    [SIZES.EIGHT_HUNDRED]: "lm:ml-800",
    [SIZES.ONE_THOUSAND]: "lm:ml-1000",
    [SIZES.ONE_THOUSAND_TWO_HUNDRED]: "lm:ml-1200",
    [SIZES.ONE_THOUSAND_SIX_HUNDRED]: "lm:ml-1600"
  },
  [_mediaQuery.QUERIES.MEDIUMMOBILE]: {
    [SIZES.NONE]: "mm:ml-0",
    [SIZES.FIFTY]: "mm:ml-50",
    [SIZES.ONE_HUNDRED]: "mm:ml-100",
    [SIZES.ONE_HUNDRED_FIFTY]: "mm:ml-150",
    [SIZES.TWO_HUNDRED]: "mm:ml-200",
    [SIZES.THREE_HUNDRED]: "mm:ml-300",
    [SIZES.FOUR_HUNDRED]: "mm:ml-400",
    [SIZES.FIVE_HUNDRED]: "mm:ml-500",
    [SIZES.SIX_HUNDRED]: "mm:ml-600",
    [SIZES.EIGHT_HUNDRED]: "mm:ml-800",
    [SIZES.ONE_THOUSAND]: "mm:ml-1000",
    [SIZES.ONE_THOUSAND_TWO_HUNDRED]: "mm:ml-1200",
    [SIZES.ONE_THOUSAND_SIX_HUNDRED]: "mm:ml-1600"
  }
};
const getMarginValue = margin => typeof margin === "number" ? `${margin}px` : margin;
const getMargin = margin => {
  if (typeof margin === "number" || typeof margin === "string") return {
    vars: {
      "--text-margin": getMarginValue(margin)
    },
    classes: ["m-[var(--text-margin)]"]
  };
  const {
    top,
    bottom,
    left,
    right
  } = margin || {};
  const cssVar = {};
  const classes = ["m-0"];
  if (top) {
    classes.push("mt-[var(--text-margin-top)]");
    cssVar["--text-margin-top"] = getMarginValue(top);
  }
  if (bottom) {
    classes.push("mb-[var(--text-margin-bottom)]");
    cssVar["--text-margin-bottom"] = getMarginValue(bottom);
  }
  if (left) {
    classes.push("ml-[var(--text-margin-left)]");
    cssVar["--text-margin-left"] = getMarginValue(left);
  }
  if (right) {
    classes.push("mr-[var(--text-margin-right)]");
    cssVar["--text-margin-right"] = getMarginValue(right);
  }
  return {
    vars: cssVar,
    classes
  };
};
exports.getMargin = getMargin;
var _default = exports.default = getMargin;